var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('brand-tabs',{attrs:{"tabs":_vm.getTabs,"current-tab":_vm.currentTab}},[_c('stored-cards-content',{attrs:{"card":_vm.currentStoredCard}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }